export const CHECKOUT_OPTIONS = {
    FULL_PAYMENT: "FULL_PAYMENT",
    NEXT_PAYMENT: "NEXT_PAYMENT",
    PARTIAL: "PARTIAL",
    PARTIAL_FLIGHTS: "PARTIAL_FLIGHTS",
    TRANSFER: "TRANSFER",
    ASSESSOR: "ASSESSOR",
};
